/**
 * Shared Firebase App singleton (Auth + multiple Firestore DBs attach to one app).
 * Split from client-db so v3db can import app without pulling in the legacy (default) db.
 */
"use client";

import { initializeApp, getApp, getApps, type FirebaseApp } from "firebase/app";

const firebaseConfig = {
  projectId: "umpiretrack",
  appId: "1:1001898017654:web:c6d1fce99803440f3d3057",
  storageBucket: "umpiretrack.firebasestorage.app",
  apiKey: "AIzaSyDCMMEjrgFrGVv4VkSeMCMoMxGu2TPfeZE",
  authDomain: "umpiretrack.firebaseapp.com",
  measurementId: "",
  messagingSenderId: "1001898017654",
};

export const app: FirebaseApp =
  !getApps().length ? initializeApp(firebaseConfig) : getApp();

export { firebaseConfig };
